import { render, staticRenderFns } from "./WorkPermitAgree.vue?vue&type=template&id=e1820b48"
import script from "./WorkPermitAgree.vue?vue&type=script&lang=js"
export * from "./WorkPermitAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports